<template>
    <div>
        <form id="document_upload_form" name="document_upload_form"
              ref="document_upload_form" class="content-inner formValidation">
            <div class="row">
                <div class="col-12">
                    <div class="panel-sub-heading headingLarge" v-if="!is_reviewing">
                        <span class="h5 display-6 markedBottom bold">{{ lang('document_upload') }}</span>
                    </div>
                </div>

                <div v-if="!!show_idpal_section" class="col-12">
                    <id-pal-verify
                        :owner-contact="`${formatTitle(signerOwner.owner_title)} ${getPrincipalFullName(signerOwner)} ${formatPhoneCode(signerOwner.owner_phone_code)} ${signerOwner.owner_phone_no}`"
                        :signer-owner="signerOwner"
                        :merchant="merchant"
                        :key="id_pal_key"
                        :is-document-upload-workflow-configured="isDocumentUploadWorkflowConfigured"
                        @success-callback="handleIdPalResponse"
                        @use-doc-upload="updateMerchantIdPal"
                        :parameters = "parameters"
                    >
                    </id-pal-verify>
                </div>

                <div v-else>
                    <div class="col-12 my-2" v-if="ekycAllowedByWorkflow">
                        <np-radios
                            :id="`ekyc_verification`"
                            :name="`ekyc_verification`"
                            :label="lang('field_ekyc_verification')"
                            :options="parameters.YES_NO_OPTIONS"
                            :mode="'co-join'"
                            @input="updateMerchantEkyc"
                            v-model="ekyc_verification">
                        </np-radios>
                        <np-notice :notice="ekycVerificationMessage"></np-notice>
                    </div>
                    <div class="col-12 my-2" v-if="hasAllDocumentCategoriesRequired">
                        <span class="font-weight black-text-color">{{ lang('all_document_categories_are_required') }}</span>
                    </div>

                    <!--            <div class="col-12 my-3">-->
                    <!--                <span class="fw-bold black-text-color">{{ lang('document_upload_help_suffix') }}</span>-->
                    <!--            </div>-->
                    <div class="col-12" v-if="document_categories.length < 1">
                        <np-skeleton type="pricing"></np-skeleton>
                    </div>
                    <div class="col-12" v-else>
                        <span class="fw-bold">{{ lang('document_upload_help_suffix') }}</span>

                        <!--<editor-fold defaultstate="collapsed" desc="Document Upload">-->
                        <div class="row mt-3">
                            <div class="col-12 mb-2" v-if="isIdPalWorkflowConfigured">
                                <a href="#" class="link-switchidpal" @click="alertSwitchToIdPal">
                                    {{ lang('switch_to_id_pal') }}
                                </a>
                            </div>
                            <div class="col-12" v-if="isSignerUser && getSignerDocumentCategories().length <= 0">
                                <np-notice :notice="lang('no_supporting_documents_uploaded')"></np-notice>
                            </div>


                                <div v-else :class="[categoryHasDocumentEntity(category) ? 'col-sm-12' : 'col-sm-4', 'd-flex align-items-stretch']"  v-for="(category, category_index) in getDocumentCategories()"
                                          :key="category.id" :id="category.id">
                                <div class="card card--upload-document" >
                                    <div class="card-body">
                                        <h5 class="card-title h5 bold">
                                            {{ formatUploadDocumentCategory(category.id) }}
                                            {{categoryIsOptional(category) ? `(${lang('optional')})` : '' }}
                                        </h5>
                                        <p :class="['card-text black-text-color', categoryHasDocumentEntity(category) ? 'height40' : '']" v-if="getDocumentCategorySubMessage(category.id).length > 0">
                                            {{getDocumentCategorySubMessage(category.id)}}
                                            <np-input
                                                :id="`document_category_${category.id}`"
                                                :name="`document_category_${category.id}`"
                                                :required="true"
                                                :hidden="true"
                                                v-show="false"
                                                v-model="category.id">
                                            </np-input>
                                        </p>

                                        <div class="row">
                                            <div class="col-lg-12">
                                                <np-select2
                                                    :key="`document_types_${category.id}`"
                                                    :id="`document_types_${category.id}`"
                                                    :name="`document_types_${category.id}`"
                                                    :label="lang('document_types')"
                                                    @input="selectDocument(category, category_index)"
                                                    :use-placeholder="false"
                                                    :parameters="getUploadDocumentTypeParams(category.id)"
                                                    v-model="category.document_type_external_id"
                                                ></np-select2>
                                            </div>
                                            <div class="col-12">
                                                <div class="row" v-if="category.selected">
                                                    <template v-for="(document, doc_index) in getDocuments()">
                                                    <div class="col-lg-12" v-if="category.id == document.document_category_external_id && document.selected === '1'">
                                                        <div class="card paddingBottom20">
                                                            <div class="card-header">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                <span>{{formatUploadDocumentType(document)}}
                                                                    <span
                                                                        v-if="!!getDocumentTooltipContent(document)"
                                                                        :title="lang('document_upload')"
                                                                        :data-popover-content="getDocumentTooltipContent(document)"
                                                                        class="helpBtn addPopover helpHeader">
                                                                        <i tabindex="-1" class="fa fa-info-circle"></i>
                                                                    </span>
                                                                </span>
                                                                        <span class="ms-2"
                                                                              v-html="formatReviewStatus(document.review_status)"></span>
                                                                        <span class="ms-1 btn btn-warning float-right float-end"
                                                                              @click="removeDocument(document, category_index)"
                                                                              v-if="isDocumentEditable(document)"><i
                                                                            class="fa fa-minus"></i></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-body">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <np-input
                                                                            :id="`document_category_${document.upload_document_type_external_id}`"
                                                                            :name="`document_category_${document.upload_document_type_external_id}`"
                                                                            :required="true"
                                                                            :hidden="true"
                                                                            v-show="false"
                                                                            v-model="document.upload_document_type_external_id">
                                                                        </np-input>
                                                                    </div>
                                                                    <div class="col-12">
                                                                        <div class="row">
                                                                            <div class="col-lg-4 col-sm-6 col-12"
                                                                                 v-if="document.document_entity_id">
                                                                                <np-select2
                                                                                    :id="`document_for_${doc_index}_${category.id}`"
                                                                                    :name="`document_for_${doc_index}_${category.id}`"
                                                                                    :required="true"
                                                                                    :label="lang('document_for')"
                                                                                    :placeholder="lang('document_for')"
                                                                                    :check_config="false"
                                                                                    @input="setDocumentEntity(document, `${doc_index}_${category.id}`)"
                                                                                    :parameters="!!document_entities_map[`${doc_index}_${category.id}`] ?
                                                                    document_entities_map[`${doc_index}_${category.id}`] :
                                                                    getEntityList(document.document_entity_id)"
                                                                                    v-model="document.selected_entity_id"
                                                                                ></np-select2>
                                                                            </div>
                                                                            <template v-for="(value) in document.values">
                                                                            <div class="col-lg-4 col-sm-6 col-12" v-if="value.attribute.selected == '1' && value.attribute.dependent != 'Y'">
                                                                                <np-input
                                                                                    v-if="isNameField(value)"
                                                                                    :ref="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :id="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :name="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :label="lang(`${value.field_name}`)"
                                                                                    :required="value.attribute.is_required == 'R'"
                                                                                    :maxlength="documentFieldMaxLength(value.field_name)"
                                                                                    :no-wrapper="false"
                                                                                    :check_config="false"
                                                                                    :rules="['alpha_name']"
                                                                                    :disabled="!isDocumentEditable(document)"
                                                                                    v-model="value.field_value">
                                                                                </np-input>
                                                                                <np-input
                                                                                    v-else-if="value.attribute.type == 'text_field' || value.attribute.type == 'postcode'"
                                                                                    :ref="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :id="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :name="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :label="lang(`${value.field_name}`)"
                                                                                    :required="value.attribute.is_required == 'R'"
                                                                                    :maxlength="documentFieldMaxLength(value.field_name)"
                                                                                    :no-wrapper="false"
                                                                                    :check_config="false"
                                                                                    :disabled="!isDocumentEditable(document)"
                                                                                    v-model="value.field_value">
                                                                                </np-input>
                                                                                <np-select2
                                                                                    v-else-if="value.attribute.type == 'country_param'"
                                                                                    :ref="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :id="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :name="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :label="lang(`${value.field_name}`)"
                                                                                    :required="value.attribute.is_required == 'R'"
                                                                                    :placeholder="lang('country')"
                                                                                    :parameters="parameters.COUNTRIES_PARAM"
                                                                                    :no-wrapper="false"
                                                                                    :check_config="false"
                                                                                    :disabled="!isDocumentEditable(document)"
                                                                                    v-model="value.field_value">
                                                                                </np-select2>
                                                                                <np-select2
                                                                                    v-else-if="value.attribute.type == 'state_param'"
                                                                                    :ref="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :id="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :name="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                    :label="lang(`${value.field_name}`)"
                                                                                    :required="value.attribute.is_required == 'R'"
                                                                                    :placeholder="lang('state')"
                                                                                    :parameters="parameters.STATES_PARAM"
                                                                                    :no-wrapper="false"
                                                                                    :check_config="false"
                                                                                    :disabled="!isDocumentEditable(document)"
                                                                                    v-model="value.field_value">
                                                                                </np-select2>
                                                                                <np-responsive v-else-if="value.attribute.type == 'date_field'">
                                                                                    <template #label>
                                                                                        <span>{{lang(`${value.field_name}`)}}</span></template>
                                                                                    <template #input>
                                                                                    <div class="form-group input-group">
                                                                                        <div class="input-group-prepend">
                                                                                            <div class="input-group-text">
                                                                                                <i class="fa fa-calendar"></i>
                                                                                            </div>
                                                                                        </div>
                                                                                        <np-date-picker
                                                                                            class="form-control"
                                                                                            :ref="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                            :id="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                            :name="`${document.id}_${doc_index}_${value.field_name}`"
                                                                                            :label="lang(`${value.field_name}`)"
                                                                                            :placeholder="lang(`${value.field_name}`)"
                                                                                            :required="value.attribute.is_required == 'R'"
                                                                                            :disabled="!isDocumentEditable(document)"
                                                                                            :check_config="false"
                                                                                            :disallow-past="disallowPast(value)"
                                                                                            :disallow-future="disallowFuture(value)"
                                                                                            :end-date="getEndDate(value)"
                                                                                            :allow-clear="true"
                                                                                            :start-date="isExpiry(value) ? '+1d' : getStartDate(category.id, document, value)"
                                                                                            :date-format="!!value.attribute.format ? value.attribute.format : 'en-GB' "
                                                                                            @input="() => value.field_value = value.field_value.replace(/[/]/g, '-')"
                                                                                            v-model="value.field_value">
                                                                                        </np-date-picker>
                                                                                    </div>
                                                                                    </template>
                                                                                </np-responsive>

                                                                            </div>
                                                                            </template>

                                                                        </div>
                                                                    </div>

                                                                    <div class="col-12">
                                                                        <div v-if="isUploading" style="text-align: center">
                                                                <span style="display: inline-block" class="btn btn-default"
                                                                ><i class="fa fa-spinner fa-spin"></i></span>
                                                                        </div>
                                                                        <ul class="list-group mb-2"
                                                                            v-if="document.uploaded_files.length > 0">
                                                                            <template  v-for="(file, file_idx) in document.uploaded_files" :key="file.id">
                                                                            <li class="mb-1 list-group-item " v-if="file.success === true">
                                                                                <div class="d-flex justify-content-between align-items-center">
                                                                                    <div style="display: block">
                                                                                <span class=""
                                                                                      style="text-transform: capitalize; font-size: 12px; word-break: normal; overflow-wrap: anywhere">
                                                                                  {{ file.name }}
                                                                                </span>
                                                                                        <span> {{ formatSize(file.size) }} </span>
                                                                                    </div>
                                                                                    <span class="fas fa-times-circle text-danger fa-1-5x"
                                                                                          @click="removeFile(document.uploaded_files, file_idx ,document)"
                                                                                          v-if="isDocumentEditable(document)">
                                                                            </span>
                                                                                </div>
                                                                            </li>
                                                                            </template>
                                                                        </ul>
                                                                    </div>
                                                                    <div class="col-12" v-if="isDocumentEditable(document)">
                                                                        <np-upload
                                                                            :key="`${document.id}_${doc_index}`"
                                                                            :id="`uploader_${document.id}_${doc_index}`"
                                                                            :ref="`uploader_${document.id}_${doc_index}`"
                                                                            :name="`${document.id}`"
                                                                            post-action="/application/ajaxdocumentupload"
                                                                            :mode="'drag-drop'"
                                                                            :maxSize="5"
                                                                            :success-callback="() => notifySuccess(lang('document_upload_successful'))"
                                                                            :error-callback="(newFile) => notifyError(lang('error'), newFile.error)"
                                                                            v-model="document.uploaded_files">
                                                                        </np-upload>
                                                                    </div>
                                                                </div> <!-- row -->
                                                            </div> <!-- Card Body -->
                                                        </div> <!-- Card -->
                                                    </div> <!-- Div with v-for -->
                                                    </template>
                                                </div> <!-- v-if="category.selected" -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>


                        </div>

                        <!--    </editor-fold>-->
                    </div>
                </div>
            </div>
            <div class="row mt-4" style="border-top: 1px solid #b2c6d0">
                <div class="col-12">

                    <div class="my-3 text-end">
                        <button type="button" v-if="!is_reviewing" :disabled="loading_document_upload" class="btn goBackBtn me-1" @click="goBack"> {{lang('go_back')}}
                        </button>
                        <a v-if="document_categories.length >= 1 && (isOpenApplication || this.isDocumentUploadAllowed)
                         && hasUploadedRequiredFiles && signerOwner.idpal_verification != '1'" @click="doContinue" class="btn uploadDocumentBtn me-1">
                            {{lang('upload_documents')}}</a>
                        <a v-else-if="isOpenApplication && signerOwner.idpal_verification == '1' && !is_reviewing" @click="doContinue" href="#" class="btn uploadDocumentBtn me-1">
                            {{lang('continue')}}
                        </a>
                        <a v-else-if="!isOpenApplication && noExpectsDocumentUpload(signerOwner) && isSignerUser" @click="doContinue" href="#" class="btn uploadDocumentBtn me-1">
                            {{lang('continue')}}
                        </a>
                        <a v-else-if="!isOpenApplication && !noExpectsDocumentUpload(signerOwner) && isSignerUser && getSignerDocumentCategories().length <= 0" @click="doContinue" href="#" class="btn uploadDocumentBtn me-1">
                            {{lang('continue')}}
                        </a>
                        <a v-else-if="isSignerUser && !noExpectsDocumentUpload(signerOwner) && signerHasUploadedFiles()" @click="doContinue" href="#" class="btn uploadDocumentBtn me-1">
                            {{lang('upload_documents')}}
                        </a>
                        <button v-else :disabled="true"  class="btn uploadDocumentBtn">
                            {{lang('upload_documents')}}</button>
                    </div>
                </div>
            </div>
        </form>

        <div id="signatories_id_document_modal" class="modal" role="dialog" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body py-2">
                        <form @submit.prevent="submitPrevent" id="signatories_proof_of_id_upload" name="signatories_proof_of_id_upload"  class="content-inner formValidation">
                            <div class="row">
                                <div class="col-12 text-center mt-3">
                                    <span class="h5 display-6 bold">{{ lang('signatories_proof_of_id_title') }}</span>
                                </div>
                                <div class="col-12 mt-5">
                                    <np-checkbox
                                        :id="`signatories_proof_of_id_confirmation`"
                                        :name="`signatories_proof_of_id_confirmation`"
                                        :no-wrapper="true"
                                        :required="true"
                                        :description="lang('signatories_proof_of_id_confirmation')"
                                        v-model="signatories_upload_documents_flag">
                                    </np-checkbox>
                                </div>
                                <div class="col-12 text-end pe-5">
                                    <button type="button" id="go-back" class="btn btn-primary me-1" @click="closeModal()">{{lang('go_back')}}</button>
                                    <button type="button" id="go-next" class="btn btn-success" @click="moveNext()">{{lang('continue')}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="exactCenter" v-if="isSignerUser && loading_document_upload">
            <div class="card">
                <div class="card-header">
                    <span class="h5 display-6 bold">{{ lang('please_wait') }}</span>
                </div>
                <div class="card-body">
                    <vue-spinner :font-size="15" :message="lang('loading')"></vue-spinner>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import documentMixin from "../../../utils/document-mixin";
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPDocumentUploadWidget,
        NPEntry,
        NPInput,
        NPModal,
        NPNotice,
        NPPhone,
        NPPostcodeSearch,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSkeleton,
        NPTextArea,
        NPUpload,
        NPVat
    } from "netpify/components";
    import VueUploadComponent from 'vue-upload-component';
    import applicationMixin from "../../../utils/application-mixin";

    import IdPalVerify from "../../../components/id-pal-verify.vue";
    import { isNavigationFailure, NavigationFailureType } from 'vue-router'
    // const  = VueRouter
    import Spinner from "vue-simple-spinner";
    import {mapState} from "pinia";
    import useApplicationStore from "../../../stores/application_module";
    import useModuleStore from "../../../stores";

    export default {
        name: "documentUpload",
        mixins: [documentMixin, applicationMixin],
        components: {
            'file-upload': VueUploadComponent,
            'np-upload-widget': NPDocumentUploadWidget,
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'np-upload': NPUpload,
            'np-notice': NPNotice,
            'np-entry': NPEntry,
            'id-pal-verify': IdPalVerify,
            'vue-spinner': Spinner,
        },
        metaInfo() {
            return {
                title: this.lang('documents_upload')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.setAppPageTitle(vm.page_label)
                if (!vm.isOpenApplication) {
                    vm.$router.push({path: `/application/view/${vm.$route.params.application_reference}/documents/`})
                }
                if (vm.isPiiDataMaskedDocument) {
                    if (vm.$route.path.includes('/application/edit')) {
                        vm.$router.push({path: `/application/edit/${vm.$route.params.application_reference}/documents_mask/`});
                    } else if (vm.$route.path.includes('/upload_documents')) {
                        vm.$router.push({path: `/application/view/${vm.$route.params.application_reference}/upload_documents_mask/`});
                    }
                }
            })
        },
        mounted() {
            setTimeout(function () {
                $('#form, #signatories_proof_of_id_upload').formValidator({
                    // triggerElement: '', //trigger element default $('form').find('button[type="submit"]')
                    triggerEvent: '', // event - default 'click'
                    defaultConfig: '', // {} - object to set different configuration in validate.js
                    scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                    additionalCallbackFunction: '',
                });
            }, 1000);
        },
//         beforeRouteLeave(to, from, next) {
//             // if (!!this.abortRouteLeave){
//             //     next();
//             //     return;
//             // }
//             if(!this.checkDestinationRoute(to, from)){ //if user is going backwards, don't validate
//                 if (this.pageHasData() && !this.disable_go_back_warning_modal) {
//                     this.alertBackRouteWarning((doCall = true) => next(doCall))
//                 } else {
//                     next()
//                     return;
//                 }
//             }else {
//                 if (!this.isOpenApplication) {
//                     next(true);
//                 } else if (from.fullPath.includes('/application/edit')) {
//                     // If open application and in edit do validate and save
//                     this.uploadDocument(to.path).then(response => next(response));
//                 } else {
//                     next();
//                 }
//             }
//         },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        computed: {
            ...mapState(useApplicationStore, {loading_document_upload:'loading_document_upload'}),
        },
        methods: {
            pageHasData: function (){
                return this.formHasValues($('#form'))
            },
            documentFieldMaxLength: function (field_name){
                if (field_name.includes('county')) {
                    return 10;
                } else if (field_name === 'document_id') {
                    return 30;
                } else {
                    return 50
                }
            },
            handleIdPalResponse: function (response) {
                const {uuid} = response;

                this.signerOwner.idpal_verification = '1';
                this.signerOwner.idpal_uuid = uuid;

                //clear all documents
                this.merchant.documents = [];
                this.id_pal_key += 1;
            },
            doContinue: function () {
                if (!this.isSignerUser && (this.isOpenApplication || this.merchantToUpload || this.hasMerchantControl)) {
                    this.merchant['signatories_upload_documents_flag'] = '0';
                }

                if (this.isOpenApplication && this.isSignerUser) {
                    this.$router.push({path: this.application_root_path + 'review/'})
                }
                if (this.signerOwner.idpal_verification != '1') {
                    let is_valid = this.validateUploadDocument();
                    if (!is_valid) {
                        return false;
                    }
                    else if(this.is_reviewing) {
                      this.uploadDocument();
                    }
                }
                if (this.isSignerUser) {
                    this.$router.push({path: this.application_root_path + 'review/'}).catch((e) => {
                        if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
                            Promise.resolve(true);
                            this.$router.push({path: this.application_root_path + 'review/'})
                        }
                    });
                } else {
                    /*
                    As we said at the beginning, there are different situations aborting a navigation, all of them resulting in different Navigation Failures. They can be differentiated using the isNavigationFailure and NavigationFailureType. There are three different types:
                    aborted: false was returned inside of a navigation guard to the navigation.
                    cancelled: A new navigation took place before the current navigation could finish. e.g. router.push was called while waiting inside of a navigation guard.
                    duplicated: The navigation was prevented because we are already at the target location.
                    */
                    let vm = this;
                    vm.$router.push({path: vm.application_root_path + 'review/'}).then(failure => {
                        if (isNavigationFailure(failure, NavigationFailureType.aborted) ||
                            isNavigationFailure(failure, NavigationFailureType.cancelled)) {
                            console.error(failure)
                            vm.$router.push({path: vm.application_root_path + 'review/'});
                        }
                    });
                }
            },
            goBack: function () {
                this.abortRouteLeave = true;
                this.$router.push({path: `${this.application_root_path}business_details/principals/`});
            },
            isNameField:  function(value) {
                return !!value && value.attribute.type == 'text_field' && (value.field_name == 'first_name' || value.field_name == 'second_name' || value.field_name == 'sur_name');
            },
            moveNext: function () {
                let validForm = this.validateForm('#signatories_proof_of_id_upload');
                if (!validForm) {
                    return false;
                }
                $('#signatories_id_document_modal').modal('hide');
                this.merchant['signatories_upload_documents_flag'] = '1';
                this['signatories_upload_documents_flag'] = '0';

                if (!this.$route.fullPath.includes('/review')) {
                    this.$router.push({path: this.application_root_path + 'review/'});
                }
                else if (this.is_reviewing && this.signerOwner.idpal_verification !== '1') {
                    this.uploadDocument();
                }
            },
            closeModal: function () {
                this['signatories_upload_documents_flag'] = '0';
                this.merchant['signatories_upload_documents_flag'] = '0';
                $('#signatories_id_document_modal').modal('hide');
            },
        }
    }
</script>

<style scoped>

.goBackBtn {
    background-color: #2C7BBC;
}

.uploadDocumentBtn {
    background-color: #4A851F;
}

.uploadDocumentBtn[disabled] {
    cursor: not-allowed;
}

.btn:disabled.uploadDocumentBtn {
    opacity: .40;
}

.black-text-color {
    color: #000000 !important;
}

.card--upload-document{
    min-height: 185px;
}

.card--upload-document p.card-text{
    min-height: 80px;
}

.card--upload-document p.card-text.height40{
    min-height: 40px;
}

.card--upload-document .card-title{
    min-height: 45px;
}

a.link-switchidpal{
    float: right;
    text-decoration: underline;
    font-size: medium;
}

a.link-switchidpal:before{
    content: "\f053";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;

}

.exactCenter {
    width:250px;
    height:200px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -100px;
    margin-left: -100px;
    z-index: 50000;
}
</style>
